import { render, staticRenderFns } from "./AccountPricing.vue?vue&type=template&id=0ad87b96"
import script from "./AccountPricing.vue?vue&type=script&lang=ts"
export * from "./AccountPricing.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ad87b96')) {
      api.createRecord('0ad87b96', component.options)
    } else {
      api.reload('0ad87b96', component.options)
    }
    module.hot.accept("./AccountPricing.vue?vue&type=template&id=0ad87b96", function () {
      api.rerender('0ad87b96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/account/AccountPricing.vue"
export default component.exports